<template>
    <div v-if="isLoading" class="loading-screen">
    </div>

    <div v-else>
    <vue-headful title="Contact" />
    <Header page_title="Contact" />
    <div class="container-fluid app-body">
      <div class="text-14">
        <p>
          Je kunt ons bereiken met
          <template v-if="companyContact && companyContact.number">
            mobiel nummer: <a :href="`tel:${companyContact.number}`">{{ companyContact.number }}</a>
          </template>
          <template v-else>
            mobiel nummer: <a href="tel:085 048 1976">085 048 1976</a>
          </template>
          of
          <template v-if="companyContact && companyContact.email">
            email: <a :href="`mailto:${companyContact.email}`">{{ companyContact.email }}</a>.
          </template>
          <template v-else>
            email: <a href="mailto:info@derect.nl">info@derect.nl</a>.
          </template>
          <br><br>
          Vragen of suggesties? Laat het ons hieronder weten! We zullen zo snel mogelijk proberen te reageren. <br>
        </p>
        <notificationContainer v-show="!isShowed"></notificationContainer>
        <form class="sd-form" @submit.prevent="onSubmit" v-show="isShowed">
          <div class="input-row">
            <div class="sd-input sd-col-12">
              <label for="form-name">Naam</label>
              <input
                id="form-name"
                type="text"
                class="form-control"
                placeholder="Naam"
                autocomplete="nope"
                v-model="form.name"
                required
              />
            </div>
            <div class="sd-input sd-col-12">
              <label for="form-email">E-mailadres</label>
              <input
                id="form-email"
                type="email"
                class="form-control"
                placeholder="E-mailadres"
                autocomplete="nope"
                v-model="form.email"
                required
              />
            </div>
            <div class="sd-input sd-col-12">
              <label for="form-contact_number">Mobiel nummer</label>
              <input
                id="form-contact_number"
                type="text"
                class="form-control"
                placeholder="Mobiel nummer"
                autocomplete="nope"
                v-model="form.contact_number"
                required
              />
            </div>
            <div class="sd-input sd-col-12">
              <label for="form-subject">Onderwerp</label>
              <input
                id="form-subject"
                type="text"
                class="form-control"
                placeholder="Onderwerp"
                autocomplete="nope"
                v-model="form.subject"
                required
              />
            </div>
            <div class="sd-input sd-col-12">
              <label for="form-message">Je bericht</label>
              <textarea
                id="form-message"
                class="form-control"
                placeholder="Je bericht"
                rows="5"
                v-model="form.message"
                required
              ></textarea>
            </div>
            <div class="sd-input sd-col-12">
              <button
                type="submit"
                class="btn btn-warning btn-block"
                v-ripple="'rgba(255, 255, 255, 0.35)'"
              >
                Verzenden
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data: function() {
      return {
        user: "",
        isShowed: true,
        form: {
          name: "",
          email: "",
          contact_number: "",
          subject: "",
          message: "",
          company_contact_mail: ""
        },
        companyContact: "",
        isLoading: false,
      };
    },
    async created() {},
    async mounted() {
        this.isLoading = true;
        this.$store.state.loading = true;
        await this.fetchData();
        this.$store.state.loading = false;
        this.isLoading = false;
    },
    watch: {
      $route: "fetchData"
    },
    methods: {
      async fetchData() {
        this.user = JSON.parse(localStorage.getItem("user"));
        if (this.user) {
          this.form.email = this.user.email;
          if (this.user.type == 1) {
            this.form.name = this.user.firstname + " " + this.user.lastname;
            this.form.contact_number = this.user.mobile;
          }
          if (this.user.type == 2) {
            this.form.name = this.user.name;
            this.form.contact_number = this.user.telephone;
          }

          if (this.user.company_contact)
          {
            this.companyContact = await this.getTokenAPIList(
                "admins/" + parseInt(this.user.company_contact)
            );
          }
        }
        if (this.companyContact && this.companyContact.email)
        {
          this.form.company_contact_mail = this.companyContact.email;
        }
      },
      async onSubmit() {
        window.scrollTo(0, 0);
        this.isShowed = !this.isShowed;
        await this.sendForm();
      },
      async sendForm() {
        return new Promise((resolve, reject) => {
          this.$store.state.loading = true;

          let formData = new FormData();
          for (var obj in this.form) {
            formData.append(obj, this.form[obj]);
          }
          var url = this.$apiURI + "/contact_us";
          this.$http
            .post(url, formData, {
              headers: {
                Accept: "application/json"
              }
            })
            .then(() => {
              const notification = {
                type: "success",
                message: "Hoppa! Je bericht is verstuurd."
              };
              this.$store.dispatch("notification/replace", notification, {
                root: true
              });
              this.form.message = "";
              this.form.subject = "";
              this.$store.state.loading = false;
              resolve();
            })
            .catch(error => {
              const notification = {
                type: "danger",
                message: error.response.data
              };
              this.$store.dispatch("notification/replace", notification, {
                root: true
              });
              this.$store.state.loading = false;
              reject();
            });
        });
      }
    }
  };
</script>

<style scoped></style>
